module.exports = __webpack_public_path__ + "static/media/guide-taste-1.ab60d320.svg";